export default __webpack_public_path__ + "static/media/checked.2bb98b31.svg";